import React from 'react';
import { Link } from 'react-router-dom';
import { useDeviceRequestBadges } from './deviceRequestApi';

/** Org Manager / Super Admin dashboard: approved requests that were not sent to the EC yet. */
export const ApprovedUnsentBanner = () => {
    const b = useDeviceRequestBadges();
    if (!(b.approvedUnsent > 0) && !(b.cannotFulfil > 0)) return null;
    return (
        <div className="alert alert-warning d-flex justify-content-between align-items-center" data-testid="dr-unsent-banner">
            <span>
                {b.approvedUnsent > 0 && <><strong>{b.approvedUnsent}</strong> approved device request{b.approvedUnsent === 1 ? ' is' : 's are'} not sent to the Enrollment Coordinator yet. </>}
                {b.cannotFulfil > 0 && <><strong>{b.cannotFulfil}</strong> came back as &quot;cannot fulfil&quot;.</>}
            </span>
            <Link className="btn btn-sm btn-warning" to={b.approvedUnsent > 0 ? '/device-requests/daily' : '/device-requests?status=CANNOT_FULFIL'}>Review</Link>
        </div>
    );
};

/** Enrollment Coordinator dashboard card. */
export const EcPendingCard = () => {
    const b = useDeviceRequestBadges();
    return (
        <Link to="/enrollment/device-requests" className="card mb-3 text-decoration-none" data-testid="dr-ec-card" style={{ maxWidth: 420 }}>
            <div className="card-body">
                <h5 className="card-title mb-1">Device Requests — Pending <span className="badge badge-danger">{b.ecPending || 0}</span></h5>
                <div className="text-muted small">
                    {b.ecPending > 0 ? `Oldest waiting ${b.ecOldestAgeDays || 0} day(s)` : 'Nothing waiting'}
                    {b.newBatches > 0 && ` · ${b.newBatches} batch(es) sent today`}
                </div>
            </div>
        </Link>
    );
};
